module.exports = __webpack_public_path__ + "img/jianying.bbf25983.png";